import React from "react"
import Link from "gatsby-link"
import Helmet from 'react-helmet'

const Kontakt = () => (
  <div>
    <article>
      <Helmet title="Muvko - Kontakt" />
      <div className="ContactInfo u-flexRow">
        <div>
          <h2>Michal</h2>
          <p>Tel: <a href="tel://+420730175491">+420 730 175 491</a></p>
        </div>
        <div>
          <h2>Katka</h2>
          <p>Tel: <a href="tel://+420730526102">+420 730 526 102</a></p>
        </div>
      </div>

      <form className="ContactForm"
        action="https://formspree.io/rejdova.kat@gmail.com"
        method="POST"
      >
        <label htmlFor="name">Jméno</label>
        <input type="text" name="name" id="name" />

        <label htmlFor="email">Email</label>
        <input type="email" name="_replyto" id="email" />

        <label htmlFor="message">Zpráva</label>
        <textarea name="message" id="message"></textarea>

        <input className="Button" type="submit" value="Poslat" />

        <input type="hidden" name="_next" value="/thanks" />
        <input type="hidden" name="_cc" value="g.sus@seznam.cz,em.starostka@gmail.com" />
      </form>
    </article>
    <iframe
      className="u-mt2"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2558.729815201262!2d14.449269316473641!3d50.11006397942979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470beb4ceb21ae9d%3A0xd344b02a79eb802e!2sEnergym!5e0!3m2!1sen!2scz!4v1520820601109"
      frameBorder="0"
      style={{ border: 0, width: '100%', height: '400px' }}
      allowFullScreen
    />
  </div>
);

export default Kontakt



// WEBPACK FOOTER //
// ./src/pages/kontakt.js